import React from "react";
import { CircleStackIcon } from "@heroicons/react/24/outline";

export const NoDataAvailable = () => {
  return (
    <div className="flex w-full h-full gap-2 items-center justify-center">
      <CircleStackIcon className="w-5 h-5" />
      No data available
    </div>
  );
};
